import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorPickerModule } from '@iplab/ngx-color-picker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatNativeDateModule } from '@angular/material/core';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TextInputHighlightModule } from 'angular-text-input-highlight';
import { MentionModule } from 'angular-mentions';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { EditorComponent } from './components/editor/editor.component';
import { ControlComponent } from './components/control/control.component';
import { LayerComponent } from './components/layer/layer.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './components/login/login.component';
import { ViewComponent, RoundPipe, SplitPipe, NumberFormatPipe, ScheduleDatePipe } from './components/view/view.component';
import { StocksComponent } from './components/stocks/stocks.component';
import { ClipboardModule } from 'ngx-clipboard';
import { DuotoneComponent } from './components/duotone/duotone.component';
import { MusicPickerComponent } from './components/music-picker/music-picker.component';

@NgModule({
  declarations: [
    AppComponent,
    EditorComponent,
    ControlComponent,
    LayerComponent,
    LoginComponent,
    ViewComponent,
    RoundPipe,
    SplitPipe,
    NumberFormatPipe,
    ScheduleDatePipe,
    StocksComponent,
    DuotoneComponent,
    MusicPickerComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    DragDropModule,
    ColorPickerModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatSelectModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatNativeDateModule,
    InfiniteScrollModule,
    BrowserAnimationsModule,
    MentionModule,
    TextInputHighlightModule,
    NgxSliderModule,
    AppRoutingModule,
    ClipboardModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
